__turbopack_context__.v({
  "bounce": "Textarea-module-scss-module__P81vFq__bounce",
  "error": "Textarea-module-scss-module__P81vFq__error",
  "errorText": "Textarea-module-scss-module__P81vFq__errorText",
  "fade-in": "Textarea-module-scss-module__P81vFq__fade-in",
  "label": "Textarea-module-scss-module__P81vFq__label",
  "pulse": "Textarea-module-scss-module__P81vFq__pulse",
  "slide-in": "Textarea-module-scss-module__P81vFq__slide-in",
  "slide-left": "Textarea-module-scss-module__P81vFq__slide-left",
  "slide-right": "Textarea-module-scss-module__P81vFq__slide-right",
  "textarea": "Textarea-module-scss-module__P81vFq__textarea",
  "textareaGroup": "Textarea-module-scss-module__P81vFq__textareaGroup",
});
